﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../core/config';
import { catchError, finalize } from 'rxjs/operators';
import { ExceptionService } from '../../core/services/exception.service';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { SearchComplaintListByAnswerTime } from '../../core/models/reports/complaints/search-complaint-list-by-answer-time';
import { SearchComplaintListByTimePeriod } from '../../core/models/reports/complaints/search-complaint-list-by-time-period';
import { SearchComplaintListByCategoryAndStatus } from '../../core/models/reports/complaints/search-complaint-list-by-category-and-status';
import { SearchComplaintListByResolvingDate } from '../../core/models/reports/complaints/search-complaint-list-by-resolving-date';
import { SearchComplaintListByProfileData } from '../../core/models/reports/complaints/search-complaint-list-by-profile-data';
import { ComplaintDetailsById } from '../../core/models/reports/complaints/complaint-details-by-id';

@Injectable({
    providedIn: 'root'
})
export class ComplaintsService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    searchComplaintsByAnswerTime(data: SearchComplaintListByAnswerTime): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.reports.complaints.searchComplaintsByAnswerTime, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintsByAnswerTime(data: SearchComplaintListByAnswerTime): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsByAnswerTime, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    searchComplaintsByTimePeriod(data: SearchComplaintListByTimePeriod): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.reports.complaints.searchComplaintsByTimePeriod, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintsByTimePeriod(data: SearchComplaintListByTimePeriod): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsByTimePeriod, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintDetailsById(data: ComplaintDetailsById): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsDetailsById, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    searchComplaintsByCategoryAndStatus(data: SearchComplaintListByCategoryAndStatus): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.reports.complaints.searchComplaintsByCategoryAndStatus, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintsByCategoryAndStatus(data: SearchComplaintListByCategoryAndStatus): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsByCategoryAndStatus, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    searchComplaintsByResolvingDate(data: SearchComplaintListByResolvingDate): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.reports.complaints.searchComplaintsByResolvingDate, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintsByResolvingDate(data: SearchComplaintListByResolvingDate): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsByResolvingDate, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    searchComplaintsByProfileData(data: SearchComplaintListByProfileData): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.reports.complaints.searchComplaintsByProfileData, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    exportComplaintsByProfileData(data: SearchComplaintListByProfileData): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.reports.complaints.exportComplaintsByProfileData, data, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

}